import type { AppDataPayload } from '../types/appData';
import type { ProjectDataPayload } from '../types/projectData';

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T/;
const DATE_KEYS = new Set([
  'createdAt',
  'updatedAt',
  'lastUpdated',
  'completedAt',
  'identifiedDate',
  'lastReviewDate',
  'targetResolutionDate',
  'closedDate',
  'timestamp',
  'plannedStartDate',
  'plannedEndDate',
  'actualStartDate',
  'actualEndDate',
  'generatedAt',
  'addedAt',
  'plannedDate',
  'actualDate',
  'date',
  'dueDate',
  'lastCalculated',
  'currentDate',
  'projectedEndDate',
  'acknowledgedAt',
  'resolvedAt',
  'lastTriggered',
  'estimatedStartDate',
  'estimatedEndDate',
  'approvedAt',
  'signedAt',
  'expiresAt',
  'acceptedAt',
  'createdOn',
  'updatedOn',
  'from',
  'to',
]);

const reviveDates = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map((entry) => reviveDates(entry));
  }

  if (value && typeof value === 'object') {
    const result: Record<string, unknown> = {};
    Object.entries(value as Record<string, unknown>).forEach(([key, entry]) => {
      if (typeof entry === 'string' && DATE_KEYS.has(key) && ISO_DATE_REGEX.test(entry)) {
        const parsed = new Date(entry);
        result[key] = Number.isNaN(parsed.getTime()) ? entry : parsed;
        return;
      }
      result[key] = reviveDates(entry);
    });
    return result;
  }

  return value;
};

export const reviveProjectDataPayload = (
  payload?: ProjectDataPayload | null
): ProjectDataPayload => {
  if (!payload || typeof payload !== 'object') {
    return {};
  }
  return reviveDates(payload) as ProjectDataPayload;
};

export const reviveAppDataPayload = (payload?: AppDataPayload | null): AppDataPayload => {
  if (!payload || typeof payload !== 'object') {
    return {};
  }
  return reviveDates(payload) as AppDataPayload;
};
